<p class="body-small text-text-common-base">
  {{ displayText() }}
</p>
